import React from 'react';

import AdminSettingsDocumentDataController from './edit-document-data.controller';

const AdminSettingsDocumentDataEditScreen = () => {
  return <AdminSettingsDocumentDataController />;
};

export default AdminSettingsDocumentDataEditScreen;
